import { defineMessages } from 'react-intl';

export default defineMessages({
    autoInsuranceTitle: {
        id: 'common.MLSideMenuItemsService.Get a Free Auto Insurance Quote',
        defaultMessage: 'Get a Free Auto Insurance Quote'
    },
    autoInsuranceVerbiage: {
        id: 'common.MLSideMenuItemsService.Did you know we have affordable auto insurance with optional features such as: Accident Forgiveness, Diminishing Deductible, or New Vehicle Replacement! Call or visit to get a quote today.',
        defaultMessage: 'Did you know we have affordable auto insurance with optional features such as: Accident Forgiveness, Diminishing Deductible, or New Vehicle Replacement! Call or visit to get a quote today.'
    },
    quoteButtonText: {
        id: 'common.MLSideMenuItemsService.Get a quote',
        defaultMessage: 'Get a quote'
    },
    umbrellaInsuranceTitle: {
        id: 'common.MLSideMenuItemsService.Get a Free Umbrella Insurance Quote',
        defaultMessage: 'Get a Free Umbrella Insurance Quote'
    },
    umbrellaInsuranceVerbiage: {
        id: 'common.MLSideMenuItemsService.Work hard? Give yourself peace of mind and don\'t put your financial security at risk, see how affordable an Umbrella policy really is.  What are you waiting for?  Call or visit to get a quote today.',
        defaultMessage: 'Work hard? Give yourself peace of mind and don\'t put your financial security at risk, see how affordable an Umbrella policy really is.  What are you waiting for?  Call or visit to get a quote today.'
    },
    homeInsuranceTitle: {
        id: 'common.MLSideMenuItemsService.Get a Free Home Insurance Quote today',
        defaultMessage: 'Get a Free Home Insurance Quote today'
    },
    homeInsuranceVerbiage: {
        id: 'common.MLSideMenuItemsService.Want to save even more? Add on a home, renter, condo policy and get a multi policy discount. With flexible coverage selections to fit your needs and budget, what are you waiting for?  Call or visit to get a quote today.',
        defaultMessage: 'Want to save even more? Add on a home, renter, condo policy and get a multi policy discount. With flexible coverage selections to fit your needs and budget, what are you waiting for?  Call or visit to get a quote today.'
    },
    valuableCoverageTitle: {
        id: 'common.MLSideMenuItemsService.Extra Coverage for Valuables',
        defaultMessage: 'Extra Coverage for Valuables'
    },
    valuableCoverageVerbiage: {
        id: 'common.MLSideMenuItemsService.Do you need extra coverage for your valuable possessions? If you have jewelry, memorbilia, furs, gold, tools, etc. you may.  Click here to add these to your policy so you are covered in the event of a loss.',
        defaultMessage: 'Do you need extra coverage for your valuable possessions? If you have jewelry, memorbilia, furs, gold, tools, etc. you may.  Click here to add these to your policy so you are covered in the event of a loss.'
    },
    addCoverageButtonText: {
        id: 'common.MLSideMenuItemsService.Add coverage',
        defaultMessage: 'Add coverage'
    },
    specialtyItemsCoverageTitle: {
        id: 'common.MLSideMenuItemsService.Specialty Items Coverage',
        defaultMessage: 'Specialty Items Coverage'
    },
    specialtyItemsCoverageVerbiage: {
        id: 'common.MLSideMenuItemsService.Are you Sports enthusiast? A gamer? Do you play an instrument? Our specialty coverage packages can help give you peace of mind for whatever happens to these special items. With only a $100 deductible, these specialty packages could make sense for you.',
        defaultMessage: 'Are you Sports enthusiast? A gamer? Do you play an instrument? Our specialty coverage packages can help give you peace of mind for whatever happens to these special items. With only a $100 deductible, these specialty packages could make sense for you.'
    },
    digitalWorldProtectionTitle: {
        id: 'common.MLSideMenuItemsService.Protection in the Digital World',
        defaultMessage: 'Protection in the Digital World'
    },
    digitalWorldProtectionVerbiage: {
        id: 'common.MLSideMenuItemsService.In today\'s digital world  libel, slander, defamation, and infringement of privacy can take on new meaning. By adding personal injury protection, you can make sure you have the right coverage to protect you and your finances should a situation like this ever arise.',
        defaultMessage: 'In today\'s digital world  libel, slander, defamation, and infringement of privacy can take on new meaning. By adding personal injury protection, you can make sure you have the right coverage to protect you and your finances should a situation like this ever arise.'
    },
    couponTitle: {
        id: 'common.MLSideMenuItemsService.Valuable Coupons & Savings',
        defaultMessage: 'Valuable Coupons & Savings'
    },
    couponVerbiage: {
        id: 'common.MLSideMenuItemsService.Like saving money? Visit MetLifeYourLife.com to find valuable coupons and discounts for smarthome devices like Honeywell Lyric Round™ Wi-fi thermostat, an ADT home security system, rental cars and more.',
        defaultMessage: 'Like saving money? Visit MetLifeYourLife.com to find valuable coupons and discounts for smarthome devices like Honeywell Lyric Round™ Wi-fi thermostat, an ADT home security system, rental cars and more.'
    },
    learnMoreButtonText: {
        id: 'common.MLSideMenuItemsService.Learn more',
        defaultMessage: 'Learn more'
    },
    newsletterTitle: {
        id: 'common.MLSideMenuItemsService.Sign up for our educational E-Newsletter',
        defaultMessage: 'Sign up for our educational E-Newsletter'
    },
    newsletterVerbiage: {
        id: 'common.MLSideMenuItemsService.Get the latest auto and home safety information and tips from MetLife Your Life - our popular customer e-newsletter.',
        defaultMessage: 'Get the latest auto and home safety information and tips from MetLife Your Life - our popular customer e-newsletter.'
    },
    signupButtonText: {
        id: 'common.MLSideMenuItemsService.Sign up now',
        defaultMessage: 'Sign up now'
    },
    homeSystemsProtectionTitle: {
        id: 'common.MLSideMenuItemsService.Home Systems Protection',
        defaultMessage: 'Home Systems Protection'
    },
    homeownerSystemsVerbiage: {
        id: 'common.MLSideMenuItemsService.Did you know as a homeowner you are responsible for pipes and wiring on your property that bring service to your house?  Protect yourself with our Home Systems Protection coverage.  It also covers home infrastructure systems, appliances and electronics.',
        defaultMessage: 'Did you know as a homeowner you are responsible for pipes and wiring on your property that bring service to your house?  Protect yourself with our Home Systems Protection coverage.  It also covers home infrastructure systems, appliances and electronics.'
    },
    homeRenterSystemsVerbiage: {
        id: 'Did you know as a renter or condo owner you may be responsible for the mechanical breakdown of home infrastructure systems, appliances and electronics? Protect yourself with our Home Systems Protection coverage.',
        defaultMessage:'Did you know as a renter or condo owner you may be responsible for the mechanical breakdown of home infrastructure systems, appliances and electronics? Protect yourself with our Home Systems Protection coverage.'
    },
    autoExtraTitle: {
        id: 'common.MLSideMenuItemsService.Auto Extra Option',
        defaultMessage: 'Auto Extra Option'
    },
    autoExtraVerbiage: {
        id: 'common.MLSideMenuItemsService.Replacing keys and locks for today\'s autos can be expensive. To learn more about this valuable endorsement and all that it covers should an event occur while on the road, click here.',
        defaultMessage: 'Replacing keys and locks for today\'s autos can be expensive. To learn more about this valuable endorsement and all that it covers should an event occur while on the road, click here.'
    },
    travelPackageTitle: {
        id: 'common.MLSideMenuItemsService.Travel Package Option',
        defaultMessage: 'Travel Package Option'
    },
    travelPackageVerbiage: {
        id: 'common.MLSideMenuItemsService.Like to see the countryside by auto or recreational vehicle? Want to make sure an accident or mechanical issue doesn\'t disrupt your plans or leave you without lodging, meals or transportation? Click here to learn more about this valuable coverage.',
        defaultMessage: 'Like to see the countryside by auto or recreational vehicle? Want to make sure an accident or mechanical issue doesn\'t disrupt your plans or leave you without lodging, meals or transportation? Click here to learn more about this valuable coverage.'
    },
    theftOfBuildingMaterialCoverageTitle: {
        id: 'common.MLSideMenuItemsService.Theft of Building Materials Coverage',
        defaultMessage: 'Theft of Building Materials Coverage'
    },
    theftOfBuildingMaterialVerbiage: {
        id: 'common.MLSideMenuItemsService.Building a house?  Think about adding this coverage to protect against the theft of materials on the home site, with additional coverage for materials in transit, lost/damaged by fire, or lightning, and more.  Protect your dreams as they become reality!',
        defaultMessage: 'Building a house?  Think about adding this coverage to protect against the theft of materials on the home site, with additional coverage for materials in transit, lost/damaged by fire, or lightning, and more.  Protect your dreams as they become reality!'
    }
});